// NATIVE
import React from 'react';

// INSTALLED
import { styled } from '@mui/material/styles';

// CUSTOM
import { useSelector } from 'react-redux';
import { useFormikContext } from 'formik';
import { Grid } from '@mui/material';
import InputNumeric from '../../formFields/InputNumeric';

export const DetailParameter = (props: any) => {
  const formikProps: any = useFormikContext();

  const { parametro } = useSelector((state: any) => state.parametros);

  const {
    formField: {
      e_llegadas_tarde,
      e_salidas_tarde,
      e_salario_minimo,
      e_auxilio_transporte,
      e_interes_cesantias,
      e_year,
    },
  } = props;

  const Div = styled('div')(({ theme }) => ({
    ...theme.typography.button,
    backgroundColor: 'wheat',
    padding: theme.spacing(8),
    textAlign: 'center',
  }));

  const setData = (parametro: any) => {
    // DATOS BASICOS

    formikProps.setFieldValue('e_llegadas_tarde', parametro.llegadas_tarde ?? 'N/A');
    formikProps.setFieldValue('e_salidas_tarde', parametro.salidas_tarde ?? 'N/A');
    formikProps.setFieldValue('e_salario_minimo', parametro.salario_minimo ?? 'N/A');
    formikProps.setFieldValue('e_auxilio_transporte', parametro.auxilio_transporte ?? 'N/A');
    formikProps.setFieldValue('e_interes_cesantias', parametro.interes_cesantias ?? 'N/A');
    formikProps.setFieldValue('e_year', parametro.year ?? 'N/A');
  };

  React.useEffect(() => {
    if (parametro && typeof parametro === 'object' && Object.keys(parametro).length > 0) {
      setData(parametro);
    }
  }, [parametro]);

  return (
    <div>
      <div>
        <Grid container>
          <Grid size={{ xs: 6 }} sx={{ padding: 2 }}>
            <InputNumeric
              name={e_year.name}
              label={e_year.label}
              variant="outlined"
              fullWidth
              inputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid size={{ xs: 6 }} sx={{ padding: 2 }}>
            <InputNumeric
              name={e_interes_cesantias.name}
              label={e_interes_cesantias.label}
              variant="outlined"
              fullWidth
              inputProps={{ readOnly: true }}
            />
          </Grid>

          <Grid size={{ xs: 6 }} sx={{ padding: 2 }}>
            <InputNumeric
              name={e_llegadas_tarde.name}
              label={e_llegadas_tarde.label}
              variant="outlined"
              fullWidth
              inputProps={{ readOnly: true }}
            />
          </Grid>

          <Grid size={{ xs: 6 }} sx={{ padding: 2 }}>
            <InputNumeric
              name={e_salidas_tarde.name}
              label={e_salidas_tarde.label}
              variant="outlined"
              fullWidth
              inputProps={{ readOnly: true }}
            />
          </Grid>

          <Grid size={{ xs: 6 }} sx={{ padding: 2 }}>
            <InputNumeric
              name={e_salario_minimo.name}
              label={e_salario_minimo.label}
              variant="outlined"
              fullWidth
              inputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid size={{ xs: 6 }} sx={{ padding: 2 }}>
            <InputNumeric
              name={e_auxilio_transporte.name}
              label={e_auxilio_transporte.label}
              variant="outlined"
              fullWidth
              inputProps={{ readOnly: true }}
            />
          </Grid>
        </Grid>
      </div>
    </div>
  );
};
